import React, { Component } from 'react';
import TimeInput from 'time-input';
import { filter, map, split } from 'lodash';


class WorkingTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workTimePickerVisible: false,
      addMoreVisibility: true,
      selectedWorkingHours: [],
      TimePickerFrom: '12:00 AM',
      TimePickerTo: "11:59 PM",
      selectedTimings: [],
      isDaySelected: false,
      errorStatus: false,
      isUniqueWorkingHours: true,

      daySelected: {
        "sunday": false, "monday": false, "tuesday": false, "wednesday": false, "thrusday": false, "friday": false, "saturday": false
      }
    };
    this.addMore = this.addMore.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      selectedTimings: nextProps.workingHours ? nextProps.workingHours : [],
    });
  }

  isUniqueDay(days){

    let isUniqueWorkingHours = true;
    let workingHours = [...this.state.selectedTimings];

    let workingDays = [];
    if (days.sunday) {
      workingDays.push(1);
    }
    if (days.monday) {
      workingDays.push(2);
    }
    if (days.tuesday) {
      workingDays.push(3);
    }
    if (days.wednesday) {
      workingDays.push(4);
    }
    if (days.thrusday) {
      workingDays.push(5);
    }
    if (days.friday) {
      workingDays.push(6);
    }
    if (days.saturday) {
      workingDays.push(7);
    }


    for(let i = 0; i < workingHours.length; i++){

        if(workingDays.includes(workingHours[i].day)){

          if(workingHours[i].range[0].from == this.state.TimePickerFrom && workingHours[i].range[0].to == this.state.TimePickerTo){
              isUniqueWorkingHours = false;
              break;
            }
        }
      }


    this.setState({
      isUniqueWorkingHours: isUniqueWorkingHours,
    });


  }
  day(selDay) {
    let days = { ...this.state.daySelected }
    days[selDay] = !this.state.daySelected[selDay]

    let fromTime = this.state.TimePickerFrom;
    let toTime = this.state.TimePickerTo;




      this.setState({
        daySelected: days,
      });
      let isDaySelected = false;
      map(days, (day) => {
        if (day == true) {
          isDaySelected = true;
        }
      });
      this.setState({ isDaySelected: isDaySelected });

      let isWorkingHourValid = this.validateWorkingHours(fromTime, toTime);
      this.props.lastWorkingHours(days, isWorkingHourValid,this.state.isUniqueWorkingHours, fromTime, toTime);

    this.isUniqueDay(days);

  }

  TimePickerChange(type, value) {
    if (type == "timeFrom") {
      this.setState({ TimePickerFrom: value });
    } else {
      this.setState({ TimePickerTo: value });
    }

  }

  validateWorkingHours(fromTime, toTime) {


    let fromHour = Number(split(fromTime, ':')[0]);
    let fromMinutes = Number(split(split(fromTime, ':')[1], ' ')[0]);
    let fromType = split(split(fromTime, ':')[1], ' ')[1];

    let toHour = Number(split(toTime, ':')[0]);
    let toMinutes = Number(split(split(toTime, ':')[1], ' ')[0]);
    let toType = split(split(toTime, ':')[1], ' ')[1];
    if (fromHour > 12 || toHour > 12) {
      return false;
    }
    if (fromType == toType) {
      if (fromHour > toHour && fromHour != 12) {
        return false;
      } else if (fromHour == toHour && fromHour != 12) {
        if (fromMinutes <= toMinutes) {
          return true;
        } else {
          return false;
        }
      } else if (fromHour != 12) {
        return true;
      } else {
        if (fromMinutes <= toMinutes) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      if (fromType == 'AM' && toType == 'PM') {
        return true;
      } else {
        return false;
      }
    }


  }

  addMore() {
    let workingHours = [...this.state.selectedTimings];

   // console.log("workingHours: "+ JSON.stringify(workingHours));
    let fromTime = this.state.TimePickerFrom;
    let toTime = this.state.TimePickerTo;



    let day = [];
    if (this.state.daySelected.sunday)
      day.push(1);

    if (this.state.daySelected.monday)
      day.push(2);

    if (this.state.daySelected.tuesday)
      day.push(3);

    if (this.state.daySelected.wednesday)
      day.push(4);

    if (this.state.daySelected.thrusday)
      day.push(5);

    if (this.state.daySelected.friday)
      day.push(6);
    if (this.state.daySelected.saturday)
      day.push(7);



    this.isUniqueDay(this.state.daySelected);

    if(this.state.isUniqueWorkingHours){



      for(let i = 0; i < day.length; i++){
          workingHours.push({
            "day": day[i],
            "range": [
              {
                "from": fromTime,
                "to": toTime
              }
            ]
          });
      }

    //  this.setState({isUniqueWorkingHours: true});


      let days = { ...this.state.daySelected }



      map(days, (day, key) => {
        days[key] = false;
      });

      let isWorkingHourValid = this.validateWorkingHours(fromTime, toTime);


      this.props.lastWorkingHours(days, isWorkingHourValid,this.state.isUniqueWorkingHours, fromTime, toTime);
      if (isWorkingHourValid) {
        this.setState({ errorStatus: false, isDaySelected: false, selectedTimings: workingHours, TimePickerTo: "11:59 PM", TimePickerFrom: "12:00 AM", daySelected: days });
        this.props.callback(workingHours);
      } else {
        console.log("error 1");

        this.setState({ errorStatus: true });
      }


    }else{
      //this.setState({ isDaySelected: true,isUniqueWorkingHours: false});
      this.setState({ isDaySelected: true});
    }



  }

  render() {

    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const workingHoursList = this.state.selectedTimings && this.state.selectedTimings.map((day, index) => {
      return (
        <div key={index}>
          <ul>
            <li>{days[day.day - 1]}</li>
            <li>{day.range[0].from} - {day.range[0].to}</li>
            <li className="remove-data">
              <i className="mdi mdi-close" onClick={() => {
                let timings = [...this.state.selectedTimings];
                timings = filter(timings, function (timing) {
                  return day != timing;
                })
                this.setState({ selectedTimings: timings });
                this.props.callback(timings);
              }}></i>
            </li>
          </ul>
        </div>
      )
    })

    return (
      <div className={this.props.isSelected ? "form-group error" : ""}>

        <div className="content-holder working-hr">

          {(this.state.selectedTimings && this.state.selectedTimings.length) ? <h5>Work Timings</h5> : ''}
          {workingHoursList}
        </div>
        {(this.props.workingHours.length && this.state.addMoreVisibility) ? <span className="addMore" onClick={() => { this.setState({ workTimePickerVisible: true, addMoreVisibility: false }); }}>Add More</span> : ''}
        {(this.state.workTimePickerVisible || this.props.workingHours.length == 0) ? <div className="content-holder time">
          <h5>Working Days</h5>
          <ul className="list-unstyled">
            <li className={this.state.daySelected["sunday"] ? 'active' : ''} onClick={this.day.bind(this, "sunday")}>SUN</li>
            <li className={this.state.daySelected["monday"] ? 'active' : ''} onClick={this.day.bind(this, "monday")}>MON</li>
            <li className={this.state.daySelected["tuesday"] ? 'active' : ''} onClick={this.day.bind(this, "tuesday")}>TUE</li>
            <li className={this.state.daySelected["wednesday"] ? 'active' : ''} onClick={this.day.bind(this, "wednesday")}>wed</li>
            <li className={this.state.daySelected["thrusday"] ? 'active' : ''} onClick={this.day.bind(this, "thrusday")}>thu</li>
            <li className={this.state.daySelected["friday"] ? 'active' : ''} onClick={this.day.bind(this, "friday")}>fri</li>
            <li className={this.state.daySelected["saturday"] ? 'active' : ''} onClick={this.day.bind(this, "saturday")}>sat</li>
          </ul>
          {this.state.isDaySelected ? <div className="row form-group error">
            <h5>Working Hours</h5>
            <div className="col-md-6 col-sm-6 col-xs-6 padLeft0 timeTo">
              <TimeInput value={this.state.TimePickerFrom} onChange={(e) => {

                let toTime = this.state.TimePickerTo;
                let isWorkingHourValid = this.validateWorkingHours(e, toTime);
                this.props.lastWorkingHours(this.state.daySelected, isWorkingHourValid, this.state.isUniqueWorkingHours, e, toTime);

                this.setState({ TimePickerFrom: e });
              }} />
            </div>
            <div className="col-md-6 col-sm-6 col-xs-6 padRight0 timeFrom">
              <TimeInput value={this.state.TimePickerTo} onChange={(e) => {

                let fromTime = this.state.TimePickerFrom;
                let isWorkingHourValid = this.validateWorkingHours(fromTime, e);
                this.props.lastWorkingHours(this.state.daySelected, isWorkingHourValid, this.state.isUniqueWorkingHours, fromTime, e);

                this.setState({ TimePickerTo: e });
              }} />
            </div>


            {(this.state.errorStatus || this.props.isError) ? <span className="error-text">Please enter valid timings.</span> : (! this.state.isUniqueWorkingHours ) ? <span className="error-text">Please enter unique timings.</span> : ''}

          </div> : ''}


        </div> : ''}
        {this.state.isDaySelected && <span className="addMore" onClick={() => {
          this.addMore();
        }}>Add More</span>}
        {this.props.isSelected && <span  className="error-text">Please choose working Hours</span>}
      </div>
    );
  }
}

export default WorkingTime;



// WEBPACK FOOTER //
// ./src/components/ProfileCreation/WorkingTime.jsx